import { render, staticRenderFns } from "./license-mng.vue?vue&type=template&id=627baef2"
import script from "./license-mng.vue?vue&type=script&lang=js"
export * from "./license-mng.vue?vue&type=script&lang=js"
import style0 from "./license-mng.vue?vue&type=style&index=0&id=627baef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports